import React from 'react';
import useRedux from 'hooks/useRedux';
import * as actionsGroupList from './admin.duck';

import Heading from '../home/components/Heading';
import Footer from '../home/components/Footer';
import ContentSection from '../home/components/ContentSection';

import DataAdmin from './components/DataAdmin';

const Main = (props) => {

    const [state, actions] = useRedux(actionsGroupList);

    const { match } = props;

    const { params } = match;
    const { mode = '' } = params;
    return <div>
        <Heading buttons={[
        ]} />
        <ContentSection>
            <div>
                <div style={{ margin: 20 }}>
                    {mode.toLowerCase() === 'data' && <DataAdmin {...{ actions, state: state.admin }} id={params.id} />}
                </div>
            </div>
        </ContentSection>
        <Footer />
    </div>
}

export default Main;


// WEBPACK FOOTER //
// ./src/admin/Main.js